module.exports = __webpack_public_path__ + "static/media/16.4d233b04.jpg";